import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import { CARD_GUTTER, COLUMN_RADIUS } from '../../../common/constants';

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CardsWrapper = styled.div<{
	isDisabled?: boolean;
	isDeletableColumn: boolean;
	isCollapsed: boolean;
}>(
	{
		flex: '1 0 auto',

		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		padding: `${CARD_GUTTER - gridSize / 4}px ${CARD_GUTTER}px ${CARD_GUTTER}px`,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		opacity: (props: any) => (props.isDisabled ? '0.5' : '1'),
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		filter: (props: any) => (props.isDisabled ? 'grayscale(100%)' : 'none'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		backgroundColor: ({ isDeletableColumn }) =>
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			isDeletableColumn ? token('color.background.danger', colors.R50) : 'inherit',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		borderBottomLeftRadius: `${COLUMN_RADIUS}px`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		borderBottomRightRadius: `${COLUMN_RADIUS}px`,
	},
	/* This container is the one detected as the destination when a card is dragging over */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ isCollapsed }) =>
		isCollapsed && {
			visibility: 'hidden',
			position: 'absolute',
			top: 0,
			bottom: 0,
			left: 0,
			right: 0,
		},
);
